var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t("Layers.title")))]),_vm._v(" "),_c('ul',_vm._l((_vm.layers),function(layer){return _c('li',{key:layer.id},[_c('router-link',{attrs:{"to":{
        name: 'Layer',
        params: { uuid: layer.id }
      }}},[_vm._v("\n        "+_vm._s(layer.name)+"\n      ")])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-590e55e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Layers.vue
// module id = null
// module chunks = 